import {
	Directive, Host, Inject,
	Input,
	OnDestroy,
} from '@angular/core';
import { WorkflowItemId, WorkflowItemStatus } from '@api/projects/interfaces';
import { WorkflowService } from '@workflow/services/workflow.service';
import { combineLatest, ReplaySubject, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import { getStatusTemplate } from '@app/components/cleanui/styles/config.defaults';
import { BADGE, IBadge, toStatus } from '@app/components/elements/badge.type';


@Directive({
	selector: '[appWfsStatusBadge]',
})
export class WfsStatusBadgeDirective implements OnDestroy {
	private readonly subscriptions: Subscription = new Subscription();
	private readonly wfsId$ = new ReplaySubject<WorkflowItemId>(1);
	private readonly wfsStatus$ = new ReplaySubject<WorkflowItemStatus>(1);
	
	// eslint-disable-next-line @angular-eslint/no-input-rename
	@Input('appWfsStatusBadge')
	set wfsId(wfsId: WorkflowItemId) {
		this.wfsId$.next(wfsId);
	}
	
	@Input()
	set status(status: WorkflowItemStatus) {
		this.wfsStatus$.next(status);
	}
	
	constructor( 
		workflowService: WorkflowService,
		@Host() @Inject(BADGE) badge: IBadge,
	) {
		const wfs$ = combineLatest([
			workflowService.workflow$,
			this.wfsId$,
		]).pipe(
			map(([workflow, wfsId]) => workflow?.items?.find(item => item.id === wfsId) ?? null),
		);
		
		this.subscriptions.add(
			combineLatest([
				wfs$,
				this.wfsStatus$,
			]).pipe(
				map(([item, status]) => getStatusTemplate(item, status)),
				map(toStatus)
			).subscribe(status => {
				badge.setStatus(status);
			}),
		);
	}
	
	ngOnDestroy(): void {
		this.subscriptions.unsubscribe();
	}
}
